// extracted by mini-css-extract-plugin
export default {"label":"En2IYV"};